import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'report-menu',
  templateUrl: './report-menu.component.html',
  styleUrls: ['./report-menu.component.css']
})
export class ReportMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
